import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Button, Col, Row } from "antd";
import TweenOne from "rc-tween-one";

import BannerImage from "components/BannerImage";
import VideoPlayer from "components/videoPlayer/VideoPlayer";

import logo from "../../../assets/images/icon-black-transparent.png";

import styles from "pages/styles.module.scss";
const WelcomePage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className={styles.welcomePage}>
      <div className={styles.bannerStyle}>
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12} className={styles.leftSide}>
            <img
              src={logo}
              alt="logo"
              style={{ width: "25%", height: "auto" }}
            />
            <p className={styles.titleWelcomeStyle}>{t("title.welcomeTo")}</p>
            <p className={styles.titleMsgClubStyle}>{t("title.msgClub")}</p>
            <p className={styles.subTitleStyle}>{t("title.subTitleWelcome")}</p>
            <div
              style={{
                width: "100%",
                height: "350px",
                maxWidth: "550px",
                marginBottom: 16,
              }}
            >
              <VideoPlayer url="https://www.youtube.com/watch?v=HMk2ib6RO4I" />
            </div>
            <div style={{ width: "auto" }}>
              <Button
                color={"blue"}
                type="primary"
                style={{
                  width: "fit-content",
                  fontSize: "1.8vw",
                  height: "auto",
                  borderRadius: "16px",
                  fontWeight: "500",
                }}
                onClick={() => {
                  navigate("/admin/workspaces");
                }}
              >
                {t("button.getStarted")}
              </Button>
            </div>
          </Col>
          <Col xs={24} sm={12}>
            <TweenOne
              animation={{ opacity: 0.5 }}
              style={{ paddingLeft: "24px", width: "85%" }}
            >
              <BannerImage />
            </TweenOne>
          </Col>
        </Row>
      </div>
    </div>
  );
};
export default WelcomePage;
